import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import GenericTable from './GenericTable';

const planNames = [
  'Plan',
  'You',
  'You & Spouse',
  'You & Children',
  'You & Family',
];

const consumerChoiceHdhp = [
  'Consumer Choice HDHP',
  '$80.08',
  '$96.86',
  '$119.43',
  '$171.84',
];

const HMOPlans = ['HMO Plans', '$93.34', '$204.22', '$210.66', '$308.22'];

const OtherPlans = ['Other Plans', '$117.24', '$181.00', '$200.00', '$254.00'];

export const tableData = {
  headers: planNames,
  rows: [
    consumerChoiceHdhp,
    HMOPlans,
    OtherPlans,
  ]
};

const GenericTableDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Generic Table</h4>
        <Row>
          <Col>
            <GenericTable selectedColumnIndex={4} tableData={tableData} />
          </Col>
        </Row>
        <Row>
          <Col>
            <GenericTable tableData={tableData} />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default GenericTableDemo;
